import { Button } from '@mantine/core';
import { IconFileTypePdf } from '@tabler/icons-react';

import { getEvaluationFacultySummaryXlsxFileDownloadUrl } from '@/module/Evaluation/model/EvaluationApi';

import { Id } from '@feature/utils';

interface EvaluationFacultySummaryButtonProps {
  evaluationId: Id;
  facultyId: Id;
}

const onDownload = (evaluationId: Id, facultyId: Id) => {
  window.open(getEvaluationFacultySummaryXlsxFileDownloadUrl(evaluationId, facultyId));
};

export function EvaluationFacultySummaryXlsxButton({ evaluationId, facultyId }: EvaluationFacultySummaryButtonProps) {
  return (
    <Button
      size="xs"
      leftSection={<IconFileTypePdf size="24px" />}
      onClick={() => onDownload(evaluationId, facultyId)}
    >
      Descarcă centralizare XLSX
    </Button>
  );
}
